import { TypedDocumentNode, gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS } from '@sorare/core/src/atoms/typography';
import { InjuryTable } from '@sorare/core/src/components/player/InjuryTable';
import {
  getPlayerInjuryColor as getPlayerInjuryColorBaseball,
  getPlayerInjuryMessage as getPlayerInjuryMessageBaseball,
} from '@sorare/core/src/lib/baseball';
import { playerDetails } from '@sorare/core/src/lib/glossary';
import { isType } from '@sorare/core/src/lib/gql';
import {
  getPlayerInjuryColor as getPlayerInjuryColorNba,
  getPlayerInjuryMessage as getPlayerInjuryMessageNba,
} from '@sorare/core/src/lib/nba';

import { PlayerInjuryReport_anyPlayer } from './__generated__/index.graphql';

type Props = {
  player: PlayerInjuryReport_anyPlayer;
};

export const PlayerInjuryReport = ({ player }: Props) => {
  if (isType(player, 'Player') || player.activeInjuries.length === 0) {
    return null;
  }

  return (
    <Vertical gap={1}>
      <HeadlineS as="h5">
        <FormattedMessage {...playerDetails.injuryReport} />
      </HeadlineS>
      {isType(player, 'BaseballPlayer') && (
        <InjuryTable
          injury={player.activeInjuries[0]!}
          getPlayerInjuryColor={getPlayerInjuryColorBaseball}
          getPlayerInjuryMessage={getPlayerInjuryMessageBaseball}
        />
      )}
      {isType(player, 'NBAPlayer') && (
        <InjuryTable
          injury={player.activeInjuries[0]!}
          getPlayerInjuryColor={getPlayerInjuryColorNba}
          getPlayerInjuryMessage={getPlayerInjuryMessageNba}
        />
      )}
    </Vertical>
  );
};

PlayerInjuryReport.fragments = {
  anyPlayer: gql`
    fragment PlayerInjuryReport_anyPlayer on AnyPlayerInterface {
      slug
      activeInjuries {
        id
        ...InjuryTable_injury
      }
    }
    ${InjuryTable.fragments.injury}
  ` as TypedDocumentNode<PlayerInjuryReport_anyPlayer>,
};
